import React from 'react'

const Measurement = () => {
  return (
    <div>Measurement</div>
  )
}

export default Measurement